import api from "./Api";

class TrocaCreditoService {
  BuscarVenda(cupom) {
    return api
      .get(`/v1/TrocaCredito/BuscarVenda?cupom=${cupom}`)
      .then((response) => response.data);
  }

  Disponiveis(payload) {
    const params = new URLSearchParams();

    if (payload?.idCliente) {
      params.append("idCliente", payload.idCliente);
    }

    if (payload?.cpfCnpj) {
      params.append("cpfCnpj", payload.cpfCnpj);
    }

    return api
      .get(`/v1/TrocaCredito/Disponiveis?${params.toString()}`)
      .then((response) => response.data);
  }

  Listar(payload) {
    const params = new URLSearchParams();
    params.append("filtro", payload?.filtro || "");
    params.append(
      "somenteDisponiveis",
      payload?.somenteDisponiveis === false ? "0" : "1"
    );

    if (payload?.idCliente) {
      params.append("idCliente", payload.idCliente);
    }

    return api
      .get(`/v1/TrocaCredito/Listar?${params.toString()}`)
      .then((response) => response.data);
  }

  Gerar(payload) {
    return api.post("/v1/TrocaCredito/Gerar", payload).then((response) => {
      return response.data;
    });
  }

  Imprimir(id) {
    return api
      .get(`/v1/TrocaCredito/Imprimir/${id}`, {
        responseType: "blob",
      })
      .then((response) => response);
  }
}

export default new TrocaCreditoService();
